// Unified API wrapper with Bearer token authentication

import { getToken } from './auth';

export const API_URL = 'https://api.crmai.greybrain.ai';

export const apiFetch = async (url: string, options: any = {}) => {
  const token = getToken();

  return fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
};
